import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import { styled } from '@mui/material/styles';

import renderInput from './input';
import renderSuggestion from './suggestion';
import renderSuggestionsContainer from './suggestions-container';

function getSuggestionValue(suggestion) {
  return suggestion.label;
}

const StyledAutocompleteRoot = styled('div')(({ theme }) => ({
  flexGrow: 1,
  position: 'relative',

  '& .autosuggest-container': {
    flexGrow: 1,
    position: 'relative'
  },

  '& .autosuggest-suggestions-container-open': {
    position: 'absolute',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    top: 50,
    left: 0,
    right: 0,
    zIndex: 100
  },

  '& .autosuggest-suggestion': {
    display: 'block'
  },

  '& .autosuggest-suggestions-list': {
    margin: 0,
    padding: 0,
    listStyleType: 'none'
  },

  '& .autosuggest-text-field': {
    width: '100%'
  }
}));

const autosuggestTheme = {
  container: 'autosuggest-container',
  suggestionsContainerOpen: 'autosuggest-suggestions-container-open',
  suggestionsList: 'autosuggest-suggestions-list',
  suggestion: 'autosuggest-suggestion'
};

const inputClasses = {
  textField: 'autosuggest-text-field'
};

class Autocomplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || props.defaultValue || '',
      suggestions: []
    };
  }

  handleSuggestionsFetchRequested = async ({ value }) => {
    const suggestions = await this.props.getSuggestions(value);
    this.setState({ suggestions });
  };

  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  handleChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });
  };

  render() {
    const {
      getSuggestions, // eslint-disable-line no-unused-vars
      inputProps = {},
      error,
      ...props
    } = this.props;

    const nextInputProps = { ...inputProps };

    if (error) {
      nextInputProps.helperText = error;
    }

    return (
      <StyledAutocompleteRoot>
        <Autosuggest
          theme={autosuggestTheme}
          renderInputComponent={renderInput}
          suggestions={this.state.suggestions}
          onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
          renderSuggestionsContainer={renderSuggestionsContainer}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={{
            error: Boolean(error),
            classes: inputClasses,
            value: this.state.value,
            onChange: this.handleChange,
            ...nextInputProps
          }}
          {...props}
        />
      </StyledAutocompleteRoot>
    );
  }
}

Autocomplete.propTypes = {
  getSuggestions: PropTypes.func.isRequired,
  inputProps: PropTypes.object,
  error: PropTypes.node,
  value: PropTypes.string,
  defaultValue: PropTypes.string
};

export default Autocomplete;
